// extracted by mini-css-extract-plugin
export var cartContainer = "_mo-4";
export var gray = "_mo-1";
export var itemContainer = "_mo-2";
export var itemDetails = "_mo-3";
export var strong = "_mo-0";